import { RolePermissionsResponse } from "../interfaces";
import { Mode } from "../RoleDetailsPage";

const getLocalePrefix = (locale: string): string => {
    return locale === "en" ? "" : `${locale}/`;
};

export const getRolePermissions = async (
    branchId: number,
    locale: string,
    roleId: number | null,
    mode: Mode = "create"
): Promise<RolePermissionsResponse> => {
    const baseUrl = process.env.REACT_APP_POS_URL;
    const localePrefix = getLocalePrefix(locale);

    let url: string;
    if (mode === "create") {
        url = `${baseUrl}/${localePrefix}api/access/branch/${branchId}/access-structure`;
    } else {
        url = `${baseUrl}/${localePrefix}api/access/branch/${branchId}/access-structure?role_id=${roleId}`;
    }

    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch role permissions: ${response.status}`);
    }

    return (await response.json()) as RolePermissionsResponse;
};
